<template>
  <section class="capabilities">
    <div class="capabilities__title-area">
      <span class="capabilities__label">{{ data.label }}</span>
      <h2 class="capabilities__title">{{ data.title }}</h2>
    </div>

    <div class="capabilities__cards">
      <CapabilityCard
        v-for="(card, index) in data.cards"
        :key="index"
        :title="card.title"
        :subtitle="card.description"
        :image="card.image"
        :bg-color="card.bgColor"
        :border-color="card.borderColor"
      />
    </div>
    <div class="title-txt">
      粤文购平台依托南方数链、区块链技术底座，严格筑牢交易安全防线，实现展商信息、交易动态公开可溯，让文化交易更安全透明高效，助力粤港澳文化产业高质量发展生态，打造“永不落幕的文博会”交易新场景。
    </div>
  </section>
</template>

<script>
import CapabilityCard from "./CapabilityCard.vue";

export default {
  name: "Capabilities",
  components: { CapabilityCard },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.capabilities {
  background-color: #f4f0e8;
  padding: 56px 40px;
  box-sizing: border-box;

  &__title-area {
    margin-bottom: 24px;
  }

  &__label {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #8c6b2f;
    letter-spacing: 1.5px;
    text-align: left;
    display: block;
  }

  &__title {
    font-family: $font-family;
    font-size: 46px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    text-align: left;
  }

  &__cards {
    display: flex;

    .capability-card {
      margin-right: 18px;
    }

    .capability-card:last-child {
      margin-right: 0;
    }
  }
  .title-txt {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
}

// 平板适配
@media (max-width: 1199px) and (min-width: 768px) {
  .capabilities {
    padding: 48px 32px;

    &__title {
      font-size: 38px;
    }

    &__cards .capability-card {
      margin-right: 16px;
    }
  }
}

// 手机适配
@media (max-width: 767px) {
  .capabilities {
    padding: 32px 20px;

    &__title-area {
      margin-bottom: 16px;
    }

    &__label {
      font-size: 11px;
    }

    &__title {
      font-size: 30px;
    }

    &__cards {
      flex-direction: column;

      .capability-card {
        margin-right: 0;
        margin-bottom: 14px;
      }

      .capability-card:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
